import api from './api';

export const getCountryCodes = async () => {
    const response = await api.request({
        method: 'get',
        url: '/otcapi/common/country/codes'
    });
    return response.data;
};
